import { type ElementType, forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { headingRecipe } from './styles/heading.styles';
import type { HeadingPropsInterface, LevelToTextStyleType } from './types/heading.types';

/**
 * @since 6.0.0
 */

export const Heading = forwardRef<HTMLHeadingElement, HeadingPropsInterface>(
  (props: HeadingPropsInterface, forwardedRef) => {
    const { className, css: cssProp, fontFamily, level = 1, textStyle, ...rest } = props;

    const levelToTextStyle: LevelToTextStyleType = {
      1: 'heading-xl',
      2: 'heading-lg',
      3: 'heading-md',
      4: 'heading-sm',
      5: 'heading-xs',
      6: 'body-lg-bold',
    };

    const styles = css(
      headingRecipe.raw({ fontFamily, textStyle: textStyle ?? levelToTextStyle[level] }),
      cssProp,
    );

    const Component: ElementType = `h${level}`;

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Heading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_heading', styles, className)}
        {...rest}
      />
    );
  },
);

Heading.displayName = 'Heading';
